import PatiosVaciosForm from "./PatiosVaciosForm";
export default PatiosVaciosForm;